import { MutableRefObject, createContext } from 'react'
import { FileViewerRef } from './FileViewerContainer'

interface FileViewerContext {
  fileViewerRef: MutableRefObject<FileViewerRef | null>
}

// A content that allows the useFileViewer() hook to access the
// FileViewerRef object that is created in the FileViewerProvider.
// This allows the hook to call methods on that, like setIsFileVisible
// and setData, to control the file viewer from anywhere in the app.
const FileViewerContext = createContext<FileViewerContext>({
  fileViewerRef: { current: null },
})
export default FileViewerContext
